import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingBalances: false,
  loadingHistory: false,
  adjusting: false,
  employeeBalances: [],
  adjustmentHistory: [],
  error: null,
};

const leaveAdjustmentReimbursementSlice = createSlice({
  name: "leaveAdjustmentReimbursement",
  initialState,
  reducers: {
    // Balances
    fetchBalancesStart: (state) => {
      state.loadingBalances = true;
      state.error = null;
    },
    fetchBalancesSuccess: (state, action) => {
      state.loadingBalances = false;
      state.employeeBalances = action.payload;
    },
    fetchBalancesFailure: (state, action) => {
      state.loadingBalances = false;
      state.error = action.payload;
    },

    // History
    fetchHistoryStart: (state) => {
      state.loadingHistory = true;
      state.error = null;
    },
    fetchHistorySuccess: (state, action) => {
      state.loadingHistory = false;
      state.adjustmentHistory = action.payload;
    },
    fetchHistoryFailure: (state, action) => {
      state.loadingHistory = false;
      state.error = action.payload;
    },

    // Adjust
    adjustBalanceStart: (state) => {
      state.adjusting = true;
      state.error = null;
    },
    adjustBalanceSuccess: (state) => {
      state.adjusting = false;
    },
    adjustBalanceFailure: (state, action) => {
      state.adjusting = false;
      state.error = action.payload;
    },

    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchBalancesStart,
  fetchBalancesSuccess,
  fetchBalancesFailure,
  fetchHistoryStart,
  fetchHistorySuccess,
  fetchHistoryFailure,
  adjustBalanceStart,
  adjustBalanceSuccess,
  adjustBalanceFailure,
  clearError,
} = leaveAdjustmentReimbursementSlice.actions;

export default leaveAdjustmentReimbursementSlice.reducer;
